import styled from 'styled-components'
import { SPACING, TYPOGRAPHY, BORDER_RADIUS, TRANSITIONS, FONT_WEIGHT } from '../../styles/theme'

export const DurationWrapper = styled.div`
  margin-top: ${SPACING.xl};
  padding-top: ${SPACING.lg};
  border-top: 1px solid var(--color-border);
`

export const DurationLabel = styled.p`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-secondary);
  margin: 0 0 ${SPACING.sm} 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

export const DurationOptions = styled.div`
  display: flex;
  gap: ${SPACING.xs};
`

export const DurationOption = styled.button<{ $selected: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: ${SPACING.sm} ${SPACING.md};
  border-radius: ${BORDER_RADIUS.lg};
  border: 1.5px solid
    ${({ $selected }) => ($selected ? 'var(--color-primary, #ac6dff)' : 'var(--color-border-dark)')};
  background: ${({ $selected }) =>
    $selected ? 'var(--color-primary-bg, rgba(172, 109, 255, 0.1))' : 'transparent'};
  cursor: pointer;
  text-align: left;
  transition:
    border-color ${TRANSITIONS.fast},
    background ${TRANSITIONS.fast};

  &:hover {
    background: var(--color-bg-secondary);
    border-color: ${({ $selected }) =>
      $selected ? 'var(--color-primary, #ac6dff)' : 'var(--color-text-tertiary)'};
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary, #ac6dff);
    outline-offset: -2px;
  }
`

export const DurationOptionName = styled.span`
  display: block;
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
  line-height: 1.2;
`

export const DurationOptionTime = styled.span`
  display: block;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: ${TYPOGRAPHY.caption.lineHeight};
  color: var(--color-text-tertiary);
`
